import Markdown from '@visma/formula/lib/Markdown';
import moment from 'moment';
import { generateTable } from './utils';
import React from 'react';

export default function DataValue({ element, formData }) {
  if (formData === undefined) {
    return null;
  }
  switch (element.type) {
    case 'text':
    case 'number':
    case 'range':
    case 'textarea':
      return formData;
    case 'bmi':
      return `${formData} kg/m²`;
    case 'richtext':
      return <Markdown>{formData}</Markdown>;
    case 'select':
      return element.messages?.fi?.[`value.${formData}`] ?? formData.toString();
    case 'boolean':
      return element.messages?.fi?.[`value.${formData}`] &&
        element.messages?.fi?.[`value.${formData}`] !== ''
        ? element.messages?.fi?.[`value.${formData}`]
        : formData === true
        ? 'Kyllä'
        : formData === false
        ? 'Ei'
        : null;
    case 'date':
      return moment(formData, 'YYYY-MM-DD').format('DD.MM.yyyy');
    case 'dateRange':
      try {
        let data = JSON.parse(formData);
        return `${
          data.start
            ? moment(data.start, 'YYYY-MM-DD').format('DD.MM.yyyy')
            : ''
        } - ${
          data.end ? moment(data.end, 'YYYY-MM-DD').format('DD.MM.yyyy') : ''
        }`;
      } catch (e) {
        break;
      }
    case 'consent':
      return 'Kyllä';
    case 'tableField':
      try {
        const tableData = JSON.parse(formData).table;
        const columns = [];
        for (const key in element.messages?.fi ?? {}) {
          if (key.startsWith('column.')) {
            columns.push(element.messages.fi[key]);
          }
        }
        return generateTable(columns, tableData);
      } catch (e) {
        console.error(e);
        return formData.toString();
      }
    default:
      return formData.toString();
  }
}
